import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { X, Play } from 'lucide-react';
const galleryItems = [{
  type: 'image',
  url: 'https://cdn.magicpatterns.com/uploads/imR5GRyS47yFzc6YyLLLZq/Campus_View.jpg',
  title: 'Campus View'
}, {
  type: 'image',
  url: 'https://cdn.magicpatterns.com/uploads/p1DBqXvm52yPAuFd4zJynF/Cultural_Program.jpg',
  title: 'Cultural Program'
}, {
  type: 'image',
  url: 'https://cdn.magicpatterns.com/uploads/fYqZSvkc2gYRuEs79Jtbjt/scholarship.png',
  title: 'Scholarship Award'
}, {
  type: 'image',
  url: 'https://cdn.magicpatterns.com/uploads/mBi4M1ncZn86x8dV1EuFbW/Science_Club.jpg',
  title: 'Science Club'
}, {
  type: 'image',
  url: 'https://cdn.magicpatterns.com/uploads/tQMctu6gVuM2JNrCfdbTNB/Students.jpg',
  title: 'Students'
}, {
  type: 'image',
  url: 'https://cdn.magicpatterns.com/uploads/6DnXWhg3NHSwsnykhRExrf/Annual_Picnic.jpg',
  title: 'Annual Picnic'
}, {
  type: 'image',
  url: 'https://cdn.magicpatterns.com/uploads/nW1bKqKP1uzG9rTC7scWV6/Annual_Sports_Day.jpg',
  title: 'Annual Sports Day'
}, {
  type: 'image',
  url: 'https://cdn.magicpatterns.com/uploads/d9tiepfmbWAFtwuaKm6iav/art_competition.jpg',
  title: 'Art Competition'
}];
export function Gallery() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  const [selectedImage, setSelectedImage] = useState<number | null>(null);
  return <section id="gallery" className="py-20 bg-light-gray" data-id="element-130">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-131">
        <div className="text-center mb-16" data-id="element-132">
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-text-dark mb-4" data-id="element-133">
            Photo & Video Gallery
          </h2>
          <div className="h-1 w-24 bg-gold mx-auto mb-4" data-id="element-134"></div>
          <p className="text-lg text-text-muted max-w-2xl mx-auto" data-id="element-135">
            Glimpses of life at MDIC
          </p>
        </div>

        <div ref={ref} className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6" data-id="element-136">
          {galleryItems.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.9
        }} animate={isVisible ? {
          opacity: 1,
          scale: 1
        } : {}} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} onClick={() => setSelectedImage(index)} className="relative aspect-square overflow-hidden rounded-lg shadow-lg hover:shadow-2xl transition-all cursor-pointer group" data-id="element-137">
              <img src={item.url} alt={item.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" data-id="element-138" />
              {item.type === 'video' && <div className="absolute inset-0 flex items-center justify-center bg-black/30" data-id="element-139">
                  <div className="bg-white/90 rounded-full p-4" data-id="element-140">
                    <Play className="text-primary" size={24} data-id="element-141" />
                  </div>
                </div>}
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end p-4" data-id="element-142">
                <p className="text-white font-semibold text-sm" data-id="element-143">{item.title}</p>
              </div>
            </motion.div>)}
        </div>
      </div>

      {/* Lightbox Modal */}
      <AnimatePresence data-id="element-144">
        {selectedImage !== null && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={() => setSelectedImage(null)} className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4" data-id="element-145">
            <button onClick={() => setSelectedImage(null)} className="absolute top-4 right-4 text-white hover:text-gold transition-colors" data-id="element-146">
              <X size={32} data-id="element-147" />
            </button>
            <motion.img initial={{
          scale: 0.8
        }} animate={{
          scale: 1
        }} exit={{
          scale: 0.8
        }} src={galleryItems[selectedImage].url} alt={galleryItems[selectedImage].title} className="max-w-full max-h-full object-contain" data-id="element-148" />
          </motion.div>}
      </AnimatePresence>
    </section>;
}